
import VueMultiselect from 'vue-multiselect'
import Icon from '@/components/UntitledUI/Icon.vue'

export default {
    name: 'InputDropdown',
    components: {
        VueMultiselect,
        Icon
    },
    props: {
        label: {
            type: [Boolean, String],
            default: null
        },
        error: {
            type: [Boolean, String],
            default: null
        },
        hint: {
            type: [Boolean, String],
            default: null
        },
        items: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: () => false
        },
        multiple: {
            type: Boolean,
            default: () => false
        },
        openDirection: {
            type: String,
            default: 'auto'
        },
        placeholder: {
            type: String,
            default: ''
        },
        selectLabel: {
            type: String,
            default: 'اضغط هنا لإضافة الخيار'
        },
        deselectLabel: {
            type: String,
            default: 'اضغط هنا لإزالة الخيار'
        },
        value: {
            type: null,
            default: null
        },
        trackBy: {
            type: String,
            default: null
        },
        showBy: {
            type: String,
            default: null
        },
        size: {
            type: String,
            default: 'sm',
            validator: val => ['sm', 'md'].includes(val)
        }
    },
    methods: {
        placeHolder () {
            let placeholder = 'يمكنك الكتابة للبحث'
            if (this.multiple) {
                placeholder += '، واختيار اكثر من خيار'
            }
            return placeholder
        }
    }
}
